import { render, staticRenderFns } from "./CoverRow.vue?vue&type=template&id=b46b0474&scoped=true&"
import script from "./CoverRow.vue?vue&type=script&lang=js&"
export * from "./CoverRow.vue?vue&type=script&lang=js&"
import style0 from "./CoverRow.vue?vue&type=style&index=0&id=b46b0474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46b0474",
  null
  
)

export default component.exports